import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;

export const StyledDiv = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
`;

export const StyledTextDiv = styled.div`
  padding-left: 8%;
`;

export const StyledTitle = styled(Title)`
  padding-left: 1%;
`;
